import isPaidSingleUseSampleVariantUtil from 'modules/variant/utils/is-paid-single-use-sample'
import hasReachedMaxFreeSamplesCountCartSelect from 'modules/cart/redux/selectors/has-reached-max-free-samples-count'
import getHasReachedMaxFreeSamplesCountMessageCartSelect from 'modules/cart/redux/selectors/get-has-reached-max-free-samples-count-message'
import updateCurrentToastAction from 'modules/toast/redux/actions/update-current'
import { GIFT_CARD_VARIANT_IDS } from 'modules/gift/constants'
import isSelectFreeBonusDeluxeSamplesStepGiftSelect from 'modules/gift/redux/selectors/is-select-bonus-deluxe-samples-step'
import hasLookInCartSelect from 'modules/cart/redux/selectors/has-look'
import isSampleVariantUtil from 'modules/variant/utils/is-sample'
import {
  UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER,
  YOU_CANT_ADD_SAMPLES_WHEN_YOU_HAVE_A_SAMPLE_BOX_IN_CART
} from 'modules/cart/constants'
import getDiscountPercentageVariantSelector from 'modules/variant/redux/selectors/get-discount-percentage'
import updateShouldCreateDiscountsCartAction from 'modules/cart/redux/actions/update-should-create-discounts'
import getCompareAtPriceProductVariantUtil from 'modules/product-variant/utils/get-compare-at-price'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'
import updateShouldEnablePSSDiscountCartUtil from 'modules/cart/utils/update-should-disable-pss-discount'
import getHasReachedMaxDeluxeSamplesCountMessageCartSelect from 'modules/cart/redux/selectors/get-has-reached-max-deluxe-samples-count-message'
import isFreeSampleVariantUtil from 'modules/variant/utils/is-free-sample'
import isDeluxeSampleVariantUtil from 'modules/variant/utils/is-deluxe-sample'
import hasReachedMaxDeluxeSamplesCountCartSelect from 'modules/cart/redux/selectors/has-reached-max-deluxe-samples'
import getUnlockedExtraFreeSamplesTierCartSelect from 'modules/cart/redux/selectors/get-unlocked-extra-free-samples-tier'
import { openSpendMoreToUnlockExtraFreeSamplesModalCartAction } from 'modules/cart/redux/actions/open-spend-more-to-unlock-extra-free-samples-modal'

/**
 * @param {toggleAddRemoveProductCartActionProps} props
 */
export default function beforeAddProductCartAction (props) {
  return (dispatch, getState) => {
    const {
      variantId,
      productVariant
    } = props

    const hasLookInCart = hasLookInCartSelect(getState())
    const isCurrentVariantAFullSize = isFullSizeVariantUtil(productVariant)
    const hasReachedMaxFreeSamplesCount = hasReachedMaxFreeSamplesCountCartSelect(getState())
    const hasReachedMaxFreeSamplesCountMessage = getHasReachedMaxFreeSamplesCountMessageCartSelect(getState())
    const hasReachedMaxDeluxeSamplesCount = hasReachedMaxDeluxeSamplesCountCartSelect(getState())
    const hasReachedMaxDeluxeSamplesCountMessage = getHasReachedMaxDeluxeSamplesCountMessageCartSelect(getState())
    const hasDiscount = !!getDiscountPercentageVariantSelector({ variantId })(getState())
    if (
      hasDiscount &&
      !getCompareAtPriceProductVariantUtil({ variant: productVariant })
    ) {
      dispatch(updateShouldCreateDiscountsCartAction(true))
      updateShouldEnablePSSDiscountCartUtil()
    }

    // if (
    //   hasSampled &&
    //   isSampleVariantUtil(productVariant)
    // ) {
    //   dispatch(updateCurrentToastAction(YOU_VE_ALREADY_SAMPLED_THIS_ITEM))
    //   return {
    //     error: YOU_VE_ALREADY_SAMPLED_THIS_ITEM
    //   }
    // }

    if (
      hasLookInCart &&
      isSampleVariantUtil(productVariant)
    ) {
      dispatch(
        updateCurrentToastAction(YOU_CANT_ADD_SAMPLES_WHEN_YOU_HAVE_A_SAMPLE_BOX_IN_CART)
      )
      return {
        error: YOU_CANT_ADD_SAMPLES_WHEN_YOU_HAVE_A_SAMPLE_BOX_IN_CART
      }
    }

    const isGiftCard = GIFT_CARD_VARIANT_IDS.includes(variantId)
    const res = (
      !isCurrentVariantAFullSize &&
      !isGiftCard
    )
    const shouldShowMaxFreeSamplesError = (
      res &&
      isFreeSampleVariantUtil(productVariant) &&
      hasReachedMaxFreeSamplesCount
    )

    const extraFreeSamplesTier = getUnlockedExtraFreeSamplesTierCartSelect(getState())
    if (
      shouldShowMaxFreeSamplesError &&
      extraFreeSamplesTier !== UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER.ABOVE_249
    ) {
      dispatch(openSpendMoreToUnlockExtraFreeSamplesModalCartAction())
      return true
    }

    if (shouldShowMaxFreeSamplesError) {
      dispatch(updateCurrentToastAction(hasReachedMaxFreeSamplesCountMessage))
      return {
        error: hasReachedMaxFreeSamplesCountMessage
      }
    }

    if (
      res &&
      (
        isDeluxeSampleVariantUtil(productVariant) ||
        isPaidSingleUseSampleVariantUtil(productVariant)
      ) &&
      hasReachedMaxDeluxeSamplesCount &&
      !isSelectFreeBonusDeluxeSamplesStepGiftSelect(getState())
    ) {
      dispatch(updateCurrentToastAction(hasReachedMaxDeluxeSamplesCountMessage))
      return {
        error: hasReachedMaxDeluxeSamplesCountMessage
      }
    }
  }
}
